import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import InputView from "../../../Componentes/Utils/InputView";
import Modal from "../../../Componentes/Utils/Modal";
import { useEffect, useRef, useState } from "react";
import { saveAs } from "file-saver";
import useApi from "../../../hooks/useApi";
import { formatBRLFromCents } from "../../../Funcoes/Money";
import { formatarData } from "../../../Funcoes/FormatarData";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import ConfirmDeleteAnexoPC from "./ConfirmDeleteAnexoPC";
import { FiDownload, FiPlus } from "react-icons/fi";
import { GoTrash } from "react-icons/go";
import {
    AiOutlineFilePdf,
    AiOutlineFileImage,
    AiOutlineFileWord,
    AiOutlineFileExcel,
    AiOutlineFileUnknown,
    AiOutlineLoading,
} from "react-icons/ai";

const Titulo = styled.h2`
    margin: 0 0 5px 3px;
    font-size: 18px;
    color: #444;
    text-align: left;
`
const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const AnexosSecaoHeader = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin: 18px 0 8px 0;
    gap: 12px;
`

const AnexosTitulo = styled.h3`
    margin: 0 0 0 3px;
    font-size: 15px;
    color: #444;
    text-align: left;
    font-weight: 600;
`

const BotaoAdicionarAnexo = styled.button`
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    padding: 8px 12px;
    box-sizing: border-box;
    transition: background 0.2s ease;
    &:hover {
        background-color: #1e40af;
    }
    &:disabled {
        background-color: #93c5fd;
        cursor: not-allowed;
    }
`

const AnexosContainer = styled.div`
    width: 100%;
    max-height: 220px;
    border: 1px solid rgba(0, 0, 0, 0.22);
    border-radius: 8px;
    box-sizing: border-box;
    overflow-y: auto;
    background: #fafafa;
`

const AnexosLista = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`

const AnexoLinha = styled.li`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 13px;
    color: #333;
    &:last-child {
        border-bottom: none;
    }
    &:nth-child(even) {
        background-color: #fff;
    }
`

const AnexoIconeTipo = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
`

const AnexoTextoCol = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
`

const AnexoNome = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
    font-size: 13px;
    color: #1e293b;
`

const AnexoTamanho = styled.span`
    font-size: 12px;
    color: #64748b;
`

const AnexoAcoes = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
`

const IconBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    color: #475569;
    transition: background 0.15s ease, color 0.15s ease;
    &:hover {
        background: rgba(0, 0, 0, 0.06);
        color: #0f172a;
    }
    &:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
`

const IconDownload = styled(FiDownload)`
    width: 18px;
    height: 18px;
`

const IconDownloadLoading = styled(AiOutlineLoading)`
    width: 18px;
    height: 18px;
    color: #2563eb;
    animation: pcAnexoDownloadSpin 0.85s linear infinite;
    @keyframes pcAnexoDownloadSpin {
        to {
            transform: rotate(360deg);
        }
    }
`

const IconDelete = styled(GoTrash)`
    width: 18px;
    height: 18px;
    color: #e11d48;
`

const AnexosVazio = styled.p`
    margin: 0;
    padding: 14px 12px;
    font-size: 13px;
    color: #64748b;
    text-align: center;
`

function formatarTamanhoArquivo(bytes) {
    const n = Number(bytes);
    if (!Number.isFinite(n) || n < 0) return "—";
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

function getFileIcon(filename) {
    const name = String(filename || "").toLowerCase();
    if (
        name.endsWith(".png") || name.endsWith(".jpg") || name.endsWith(".jpeg")
        || name.endsWith(".gif") || name.endsWith(".webp") || name.endsWith(".bmp")
    ) {
        return <AiOutlineFileImage size={24} color="#4a90e2" />;
    }
    if (name.endsWith(".pdf")) return <AiOutlineFilePdf size={24} color="#e63946" />;
    if (name.endsWith(".doc") || name.endsWith(".docx")) {
        return <AiOutlineFileWord size={24} color="#2a6db0" />;
    }
    if (name.endsWith(".xls") || name.endsWith(".xlsx")) {
        return <AiOutlineFileExcel size={24} color="#207245" />;
    }
    return <AiOutlineFileUnknown size={24} color="#64748b" />;
}

function nomeArquivoAnexo(anexo) {
    return anexo.original_nome || anexo.serv_nome || "Arquivo";
}

const ModalViewItem = ({ isPedido, id, fecharModal }) => {

    const api = useApi();

    const [itemData, setItemData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [downloadingIds, setDownloadingIds] = useState([]);
    const [anexoParaExcluir, setAnexoParaExcluir] = useState(null);
    const [uploadingAnexos, setUploadingAnexos] = useState(false);
    const fileInputAnexosRef = useRef(null);

    const idAlvoAnexos = id;

    const handlePickAnexos = () => {
        fileInputAnexosRef.current?.click();
    };

    const handleAnexosFilesChange = async (e) => {

        const files = Array.from(e.target.files || []);
        e.target.value = "";
        if (!files.length || idAlvoAnexos == null) return;

        setUploadingAnexos(true);

        try {

            const formData = new FormData();
            if (isPedido) {
                formData.append("idPedido", String(idAlvoAnexos));
            } else {
                formData.append("idAditivo", String(idAlvoAnexos));
            }
            files.forEach((file) => {
                formData.append("files[]", file);
            });

            const addUrl = isPedido
                ? "/Painel/API/ControleMedicao/AddPCAnexo/"
                : "/Painel/API/ControleMedicao/AddADTVAnexo/";

            const { data } = await api.post(addUrl, formData);
            const incoming = Array.isArray(data?.anexos) ? data.anexos : [];

            setItemData((prev) => {
                if (!prev) return prev;
                const rest = Array.isArray(prev.anexos) ? prev.anexos : [];
                return { ...prev, anexos: [...incoming, ...rest] };
            });

        } catch (err) {

            console.error(err);

        } finally {

            setUploadingAnexos(false);

        }

    };

    const handleDownloadAnexo = async (anexo) => {

        if (anexo?.id == null) {
            console.warn("Anexo sem id para download:", anexo);
            return;
        }

        const aid = anexo.id;
        setDownloadingIds((prev) => (prev.includes(aid) ? prev : [...prev, aid]));

        try {

            const downloadUrl = isPedido
                ? `/Painel/API/ControleMedicao/DownloadPCAnexo/index.php?id=${aid}`
                : `/Painel/API/ControleMedicao/DownloadADTVAnexo/index.php?id=${aid}`;

            const { data } = await api.get(downloadUrl, { responseType: "blob" });
            saveAs(data, nomeArquivoAnexo(anexo));

        } catch (e) {

            console.error(e);

        } finally {

            setDownloadingIds((prev) => prev.filter((x) => x !== aid));

        }

    };

    useEffect(() => {

        let cancelled = false;

        const load = async () => {

            if (id == null) {
                if (!cancelled) setLoading(false);
                return;
            }

            if (!cancelled) setLoading(true);

            try {

                const url = isPedido ? `/Painel/API/ControleMedicao/GetPedido/index.php?id=${id}` : `/Painel/API/ControleMedicao/GetAditivo/index.php?id=${id}`;
                const { data } = await api.get(url);

                if (!cancelled) setItemData(data);

            } catch (e) {

                console.error(e);

            } finally {

                if (!cancelled) setLoading(false);

            }

        };

        load();
        return () => { cancelled = true; };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- useApi retorna nova instância a cada render
    }, [id, isPedido]);


    const anexos = Array.isArray(itemData?.anexos) ? itemData.anexos : [];
    const valorFat = Number(itemData?.valor_faturamento) || 0;
    const valorFatDir = Number(itemData?.valor_faturamento_direto) || 0;

    return (
        <>
            <Overlay state={true} >
                <Modal
                    header
                    close={fecharModal}
                >
                    {
                        loading ? (
                            <SmallLoading />
                        ) : (
                            <>
                                <Titulo>{isPedido ? "PEDIDO DE COMPRA" : "ADITIVO"}</Titulo>
                                <Wrapper>
                                    <InputView
                                        label="OBRA:"
                                        value={itemData ? itemData.obra : ""}
                                    />
                                    <InputView
                                        label="Nº PEDIDO DE COMPRA:"
                                        value={itemData ? itemData.num_pedido : ""}
                                    />
                                    <InputView
                                        label="VALOR FATURAMENTO:"
                                        value={itemData ? formatBRLFromCents(valorFat) : "R$ 0,00"}
                                    />
                                    <InputView
                                        label="VALOR FATURAMENTO DIRETO:"
                                        value={itemData ? formatBRLFromCents(valorFatDir) : "R$ 0,00"}
                                    />
                                    <InputView
                                        label="VALOR TOTAL:"
                                        value={itemData ? formatBRLFromCents(valorFat + valorFatDir) : "R$ 0,00"}
                                    />
                                    <InputView
                                        label="TIPO CONTRATO:"
                                        value={itemData ? itemData.tipo_contrato : ""}
                                    />
                                    <InputView
                                        label="NOME PROJETO:"
                                        value={itemData ? itemData.nome_projeto : ""}
                                    />
                                    <InputView
                                        label="PASP"
                                        value={itemData ? itemData.pasp : ""}
                                    />
                                    <InputView
                                        label="DESCRIÇÃO:"
                                        value={itemData ? itemData.descricao : ""}
                                    />
                                    <InputView
                                        label="CONTRATANTE:"
                                        value={itemData ? itemData.contratante : ""}
                                    />
                                    <InputView
                                        label="OBSERVAÇÕES:"
                                        value={itemData ? itemData.observacoes : ""}
                                        textarea
                                    />
                                    <InputView
                                        label="N DO CONTRATO:"
                                        value={itemData ? itemData.num_contrato : ""}
                                    />
                                    <InputView
                                        label="DATA DO CONTRATO:"
                                        value={itemData ? formatarData(itemData.data_contrato) : ""}
                                    />
                                    <InputView
                                        label="ART"
                                        value={itemData ? itemData.art : ""}
                                    />
                                    <InputView
                                        label="CNO"
                                        value={itemData ? itemData.cno : ""}
                                    />
                                </Wrapper>
                                <AnexosSecaoHeader>
                                    <AnexosTitulo>ANEXOS</AnexosTitulo>
                                    <input
                                        ref={fileInputAnexosRef}
                                        type="file"
                                        multiple
                                        style={{ display: "none" }}
                                        onChange={handleAnexosFilesChange}
                                    />
                                    <BotaoAdicionarAnexo
                                        type="button"
                                        title="Adicionar anexo"
                                        aria-label="Adicionar anexo"
                                        disabled={uploadingAnexos || idAlvoAnexos == null}
                                        onClick={handlePickAnexos}
                                    >
                                        <FiPlus size={18} strokeWidth={2.5} />
                                        {uploadingAnexos ? "ENVIANDO..." : "ADICIONAR ANEXO"}
                                    </BotaoAdicionarAnexo>
                                </AnexosSecaoHeader>
                                <AnexosContainer>
                                    {anexos.length === 0 ? (
                                        <AnexosVazio>Nenhum anexo cadastrado.</AnexosVazio>
                                    ) : (
                                        <AnexosLista>
                                            {anexos.map((anexo) => {
                                                const nome = nomeArquivoAnexo(anexo);
                                                const baixando = anexo.id != null && downloadingIds.includes(anexo.id);
                                                return (
                                                    <AnexoLinha key={anexo.id ?? `${anexo.serv_nome}-${anexo.original_nome}`}>
                                                        <AnexoIconeTipo title={nome}>
                                                            {getFileIcon(nome)}
                                                        </AnexoIconeTipo>
                                                        <AnexoTextoCol>
                                                            <AnexoNome title={nome}>{nome}</AnexoNome>
                                                            <AnexoTamanho>{formatarTamanhoArquivo(anexo.tamanho)}</AnexoTamanho>
                                                        </AnexoTextoCol>
                                                        <AnexoAcoes>
                                                            <IconBtn
                                                                type="button"
                                                                title="Baixar arquivo"
                                                                aria-label="Download"
                                                                disabled={baixando}
                                                                onClick={() => handleDownloadAnexo(anexo)}
                                                            >
                                                                {baixando ? (
                                                                    <IconDownloadLoading aria-hidden />
                                                                ) : (
                                                                    <IconDownload />
                                                                )}
                                                            </IconBtn>
                                                            <IconBtn
                                                                type="button"
                                                                title="Excluir arquivo"
                                                                aria-label="Excluir anexo"
                                                                disabled={anexo.id == null}
                                                                onClick={() => anexo.id != null && setAnexoParaExcluir(anexo)}
                                                            >
                                                                <IconDelete />
                                                            </IconBtn>
                                                        </AnexoAcoes>
                                                    </AnexoLinha>
                                                );
                                            })}
                                        </AnexosLista>
                                    )}
                                </AnexosContainer>
                            </>
                        )
                    }

                </Modal>
            </Overlay>
            {anexoParaExcluir && (
                <ConfirmDeleteAnexoPC
                    id={anexoParaExcluir.id}
                    isPedido={isPedido}
                    fecharModal={() => setAnexoParaExcluir(null)}
                    onDelete={() => {
                        const aid = anexoParaExcluir.id;
                        setItemData((prev) => {
                            if (!prev || !Array.isArray(prev.anexos)) return prev;
                            return { ...prev, anexos: prev.anexos.filter((a) => a.id !== aid) };
                        });
                    }}
                />
            )}
        </>
    )

}

export default ModalViewItem;